import React from 'react';
import Pro01 from "../../images/services/rd/Offering-Our-Best-To-The-World-For-A-Brighter-Tomorrow.webp";
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Agile(props) {
    return (
        <div className="tekrevol_gray_bg p-100">
            <Container classNanme="h-100">
                <Row classNanme="h-100">
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5}>
                        <div className="example" data-text="Offering">
                            <h2>Offering Our Best To The World For A Brighter Tomorrow</h2>
                        </div>
                        <p>
                            TekRevol is proud of itself as the leading technology solutions provider with a significant impact in the market. Our global projects have helped numerous businesses earn millions in revenue and enabled multiple startups to strengthen their foundations and kickstart their journey in the digital world. TekRevol’s research and development services empower established businesses to revamp their products with a fresh feel and enable new businesses to perfect every aspect before launch to ease the pre-launch and post-launch pressure. Let us do the research you need.
                        </p>

                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="agile_title my-auto offset-xl-1">
                        <div className="content_pointer">
                            <div className="pointers_item">
                                <div className="title_count">21+<span>projects completed</span></div>
                            </div>
                            <div className="pointers_item">
                                <div className="title_count">23+<span>businesses served</span></div>
                            </div>
                            <div className="pointers_item">
                                <div className="title_count">9+<span>industries covered</span></div>
                            </div>
                        </div>
                        <LazyLoadImage
                            src={Pro01}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Agile;